// Full legal copy for Royal Solutions – verbatim from client.

export const COMPANY = {
  name: "Royal Solutions",
  cvr: "46752309",
  phone: "+45 71 41 87 05",
  email: "Royal-solutions@hotmail.com",
  website: "royalsolutions.dk",
};

export const TERMS_DOC = {
  slug: "handelsbetingelser",
  title: "Handelsbetingelser",
  kicker: "Vilkår",
  showCompany: true,
  sections: [
    {
      n: "1",
      title: "Generelt",
      paras: [
        "Royal Solutions leverer serviceydelser til private og erhverv, herunder events, bryllupper, fester, personale, rengøring, havearbejde og flyttehjælp.",
        "En forespørgsel via hjemmesiden er ikke en bindende booking. En booking bliver først bindende, når Royal Solutions og kunden har accepteret aftalen.",
      ],
    },
    {
      n: "2",
      title: "Kundens oplysninger",
      paras: [
        "Kunden skal give korrekte oplysninger om adresse, dato, tidspunkt, adgangsforhold, opgavens omfang og særlige forhold. Kunden skal informere om skrøbelige, værdifulde eller særlige genstande/overflader.",
      ],
    },
    {
      n: "3",
      title: "Ændringer og ekstraarbejde",
      paras: [
        "Ændringer eller ekstraarbejde skal så vidt muligt aftales på forhånd og kan medføre ekstra betaling.",
      ],
    },
    {
      n: "4",
      title: "Ventetid",
      paras: [
        "Hvis Royal Solutions må vente mere end 15 minutter på grund af kunden, manglende adgang eller forhold på kundens side, kan ventetiden medregnes som arbejdstid.",
      ],
    },
    {
      n: "5",
      title: "Betaling",
      paras: [
        "Private kunder betaler som udgangspunkt samme dag efter udført opgave, medmindre andet er aftalt.",
        "Erhvervskunder og faste aftaler kan efter aftale have betalingsfrist, normalt 14 dage.",
        "Ved for sen betaling kan renter og gebyrer opkræves efter gældende lovgivning.",
      ],
    },
    {
      n: "6",
      title: "Almindelige serviceydelser – afbud",
      items: [
        "48+ timer før: Gratis",
        "24–48 timer: 50 %",
        "Under 24 timer/no-show: 100 %",
      ],
      note: "Gælder fx rengøring, havearbejde og flyttehjælp. Lovbestemte forbrugerrettigheder gælder altid.",
    },
    {
      n: "7",
      title: "Personale til fest & event",
      paras: ["Minimumsbooking: 4 timer pr. medarbejder."],
      items: [
        "96+ timer før: Gratis",
        "48–96 timer: 50 % af minimumsbookingen",
        "Under 48 timer: 100 % af minimumsbookingen",
      ],
    },
    {
      n: "8",
      title: "Events – betaling",
      paras: ["Som udgangspunkt:"],
      items: ["25 % ved booking", "50 % 30 dage før", "25 % 7 dage før"],
      note: "Den konkrete betalingsplan fremgår af tilbud/ordrebekræftelse.",
    },
    {
      n: "9",
      title: "Events – kuverter",
      paras: [
        "Antallet af kuverter kan som udgangspunkt reduceres frem til 7 dage før arrangementet.",
        "Ved reduktion 0–6 dage før kan Royal Solutions opkræve den bekræftede/ordrerede kuvertpris for de aflyste kuverter.",
      ],
    },
    {
      n: "10",
      title: "Events – afbestilling",
      items: [
        "30+ kalenderdage: 0 %",
        "21–29 dage: 25 %",
        "13–20 dage: 50 %",
        "7–12 dage: 75 %",
        "0–6 dage: 100 %",
      ],
      note: "Lovbestemte forbrugerrettigheder og konkrete aftalevilkår gælder altid.",
    },
    {
      n: "11",
      title: "Klager",
      paras: [
        "Fejl eller mangler skal meddeles hurtigst muligt. Kunden bedes beskrive problemet og gerne vedlægge billeder eller dokumentation.",
        "Royal Solutions forsøger at løse eventuelle problemer hurtigt og rimeligt.",
      ],
    },
    {
      n: "12",
      title: "Fortrydelsesret",
      paras: [
        "Private kunder har de forbrugerrettigheder, herunder eventuel lovbestemt fortrydelsesret, som følger af dansk lovgivning.",
        "Hvis kunden ønsker, at en service påbegyndes inden udløbet af en eventuel fortrydelsesfrist, håndteres dette efter gældende regler.",
        "For ydelser knyttet til en bestemt dato/periode kan særlige undtagelser gælde.",
      ],
    },
    {
      n: "13",
      title: "Ansvar",
      paras: [
        "Royal Solutions udfører arbejdet professionelt og med rimelig omhu. Ansvar vurderes efter gældende dansk lovgivning og den konkrete aftale.",
      ],
    },
    {
      n: "14",
      title: "Force majeure",
      paras: [
        "Royal Solutions er ikke ansvarlig for manglende opfyldelse på grund af ekstraordinære forhold uden for virksomhedens rimelige kontrol.",
      ],
    },
    {
      n: "15",
      title: "Ændring af vilkår",
      paras: [
        "Royal Solutions kan opdatere handelsbetingelserne. Den version, der gælder for den konkrete aftale, anvendes som udgangspunkt.",
      ],
    },
  ],
};

export const PRIVACY_DOC = {
  slug: "privatlivspolitik",
  title: "Privatlivspolitik",
  kicker: "Persondata",
  intro:
    "Royal Solutions behandler personoplysninger ansvarligt og efter gældende databeskyttelseslovgivning.",
  showCompany: true,
  companyHeading: "Dataansvarlig",
  sections: [
    {
      title: "Oplysninger",
      paras: [
        "Vi kan behandle navn, telefon, e-mail, adresse, virksomhedsoplysninger, booking-/tilbudsoplysninger, fakturerings-/betalingsoplysninger, kommunikation samt oplysninger kunden selv sender via formularer eller upload.",
      ],
    },
    {
      title: "Formål",
      paras: ["Oplysninger bruges til at:"],
      items: [
        "besvare henvendelser",
        "udarbejde tilbud",
        "håndtere bookinger",
        "levere services",
        "kontakte kunden",
        "håndtere betaling og fakturering",
        "yde kundeservice",
        "håndtere klager",
        "opfylde juridiske og regnskabsmæssige krav.",
      ],
    },
    {
      title: "Opbevaring",
      paras: [
        "Personoplysninger opbevares kun så længe, det er nødvendigt, eller så længe lovgivningen kræver det.",
      ],
    },
    {
      title: "Videregivelse",
      paras: [
        "Oplysninger kan deles med relevante databehandlere/samarbejdspartnere, når det er nødvendigt for at levere en aftalt service eller opfylde juridiske krav.",
        "Royal Solutions sælger ikke kunders personoplysninger.",
      ],
    },
    {
      title: "Dine rettigheder",
      paras: [
        "Efter gældende regler kan du have ret til indsigt, rettelse, sletning, begrænsning, indsigelse og dataportabilitet.",
        "Kontakt Royal Solutions på Royal-solutions@hotmail.com ved spørgsmål om persondata.",
      ],
    },
    {
      title: "Sikkerhed",
      paras: [
        "Royal Solutions anvender passende tekniske og organisatoriske sikkerhedsforanstaltninger for at beskytte personoplysninger.",
      ],
    },
  ],
};
